import { type FC, type ReactNode } from "react";
import { useBooleanState } from "~/common/hooks/useBooleanState";
import ConfirmationModal from "~/common/components/ConfirmationModal";
import { useTranslation } from "react-i18next";

interface Props {
  children: (openConfirmation: () => void) => ReactNode;
  onConfirm: () => void;
  onCancel?: () => void;
  label: ReactNode;
  okLabel: ReactNode;
  cancelLabel: ReactNode;
}

export const ConfirmationContext: FC<Props> = ({ children, onConfirm, onCancel, ...rest }) => {
  const { val: isOpen, setTrue: open, setFalse: close } = useBooleanState(false);

  return (
    <>
      {children(open)}
      {isOpen && (
        <ConfirmationModal
          onOk={() => {
            close();
            onConfirm();
          }}
          onCancel={() => {
            close();
            if (onCancel) {
              onCancel();
            }
          }}
          {...rest}
        />
      )}
    </>
  );
};
export const DefaultConfirmationContext: FC<Pick<Props, "children" | "onConfirm" | "onCancel">> = (props) => {
  const { t } = useTranslation();

  const label = t("generic.confirm.continue");
  const okLabel = t("generic.ok");
  const cancelLabel = t("common.no");

  return <ConfirmationContext {...props} label={label} okLabel={okLabel} cancelLabel={cancelLabel} />;
};
